export const fragrance = [
    {
      pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw9a2d9927/crop/026481809_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
      category: "New!",
      id: "41",
      name: "Monstr Tree NIghtlight",
      category1: "Wallflowers Fragrance Plug",
      Amount: "32.50",
      Rating: "5",
    },
    {
      pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwf81ca241/crop/026481807_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
      category: "New!",
      id: "42",
      name: "Evil Apple Nightlight",
      category1: "Wallflower Fragrance Plug",
      Amount: "18.50",
      Rating: "4.5",
    },
    {
      pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwd2b9219a/crop/026553493_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
      category: "New!",
      id: "43",
      name: "Pumpkin Pecan Waffles",
      category1: "Wallflower Fragrance Refill, 2-Pack",
      Amount: "14.50",
      Rating: "5",
    },
    {
      pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw954c09d2/crop/026555584_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
      category: "New!",
      id: "44",
      name: "Walk in the Forest",
      category1: "Single Wick Candle",
      Amount: "15.50",
      Rating: "2",
    },
    {
      pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwd2b9219a/crop/026553493_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
      category: "New!",
      id: "45",
      name: "Fresh Balsam",
      category1: "Wallflower Fragrance Refils, 2-Packs",
      Amount: "14.50",
      Rating: "5",
    },
    {
      pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw954c09d2/crop/026555584_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
      category: "New!",
      id: "46",
      name: "Leaves",
      category1: "Wallflower Fragrance Refils",
      Amount: "7.50",
      Rating: "4.5",
    },
    {
      pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw90fbce9c/crop/026536756_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
      category: "New!",
      id: "47",
      name: "Leaves",
      category1: "3-Wick Candle",
      Amount: "13.50",
      Rating: "6",
    },
    {
      pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwa9c1a926/crop/026481811_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
      category: "New!",
      id: "48",
      name: "Succulent Skull Nightlight",
      category1: "Wallflower Fragrance Plug",
      Amount: "18.50",
      Rating: "5",
    },
    {
      pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw725a0a97/crop/026553736_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
      category: "New!",
      id: "49",
      name: "Sweet Cinnamon Pumpkin",
      category1: "Wallflower Fragrance Refils, 2-Packs",
      Amount: "14.50",
      Rating: "5",
    },
    {
      pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwbe95cfa2/crop/026247726_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
      category: " ",
      id: "50",
      name: "Crystal Ball Nightlight",
      category1: "Wallflower Fragrance Plug",
      Amount: "18.95",
      Rating: "4.5",
    },
    {
      pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwa4a210a0/crop/026553735_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
      category: "Online Exclusive",
      id: "51",
      name: "Warm Apple Pie",
      category1: "Wallflower Fragrance Refils, 2-Packs",
      Amount: "14.50",
      Rating: "4",
    },
    {
      pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw0bead625/crop/026553814_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
      category: "New",
      id: "52",
      name: "Honeycrip Apple",
      category1: "Wallflower Fragrance Refils, 2-Packse",
      Amount: "14.50",
      Rating: "4",
    },
    {
      pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw33b7f657/crop/026555561_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
      category: "New!",
      id: "53",
      name: "Vampire Blood",
      category1: "Wallflower Fragrance Refils",
      Amount: "7.50",
      Rating: "4",
    },
    {
      pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwa684371a/crop/026553498_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
      category: "New!",
      id: "54",
      name: "Lakeside Morning",
      category1: "Wallflower Fragrance Refill",
      Amount: "7.90",
      Rating: "5",
    },
    {
      pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dweb4c212e/crop/026553815_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
      category: "New!",
      id: "55",
      name: "Leaves",
      category1: "Wallflower Fragrance Refill",
      Amount: "14.50",
      Rating: "5",
    },
    {
      pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw7b97de57/crop/026553739_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
      category: "New!",
      id: "56",
      name: "Welcome Home",
      category1: "Wallflower Fragrance Refills,2-Packs",
      Amount: "14.50",
      Rating: "5",
    },
    {
      pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw03aa8548/crop/026481815_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
      category: "New!",
      id: "57",
      name: "Neon Bat Nightlight",
      category1: "Wallflower Fragrance Refill",
      Amount: "22.50",
      Rating: "5",
    },
    {
      pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw93fdcecf/crop/026412381_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
      category: "New!",
      id: "58",
      name: "Lavender Vanilla",
      category1: "Wallflower Refill 2-Packs",
      Amount: "14.50",
      Rating: "4.5",
    },
    {
      pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dwb4a5f4bc/crop/026412385_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
      category: "New Fragrance",
      id: "59",
      name: "Laundry Day",
      category1: "Wallflower Refill 2-Packs",
      Amount: "14.50",
      Rating: "4.5",
    },
    {
      pImg: "https://cdn-fsly.yottaa.net/5d669b394f1bbf7cb77826ae/www.bathandbodyworks.com/v~4b.216/dw/image/v2/BBDL_PRD/on/demandware.static/-/Sites-master-catalog/default/dw184b22ab/crop/026553820_crop.jpg?sw=500&sh=600&sm=fit&q=75&yocs=o_s_",
      category: "New!",
      id: "60",
      name: "The Perfect Autumn",
      category1: "Wallflower Refill 2-Packs",
      Amount: "14.50",
      Rating: "5",
    },
  ];
  